import { VpButton, VpIcon, VpIconButton } from '@vtmn-play/react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'

type OnboardingWelcomeModalProps = Readonly<{
  isOpen: boolean
  onDismiss: () => void
  onStart: () => void
}>

export function ProductGalleryOnboardingWelcomeModal({
  isOpen,
  onDismiss,
  onStart,
}: OnboardingWelcomeModalProps) {
  const { t } = useTranslation()

  if (!isOpen) {
    return null
  }

  return createPortal(
    <div className="product-gallery-onboarding__welcome" data-testid="product-gallery-onboarding-welcome">
      <div className="product-gallery-onboarding__backdrop" aria-hidden="true" />
      <div className="product-gallery-onboarding__welcome-dialog" role="dialog" aria-modal="true" aria-labelledby="product-gallery-onboarding-welcome-title">
        <div className="product-gallery-onboarding__tooltip-header">
          <h2 id="product-gallery-onboarding-welcome-title">
            {t('products-page.onboarding.welcome.title')}
          </h2>
          <VpIconButton
            aria-label={t('close')}
            className="product-gallery-onboarding__close"
            variant="tertiary"
            size="small"
            onClick={onDismiss}
          >
            <VpIcon name="close" />
          </VpIconButton>
        </div>
        <p className="product-gallery-onboarding__welcome-text">
          {t('products-page.onboarding.welcome.description-1')}
          <br />
          {t('products-page.onboarding.welcome.description-2')}
        </p>
        <div className="product-gallery-onboarding__welcome-actions">
          <VpButton variant="secondary" size="medium" onClick={onDismiss}>
            {t('products-page.onboarding.welcome.dismiss')}
          </VpButton>
          <VpButton variant="primary" size="medium" onClick={onStart}>
            {t('products-page.onboarding.welcome.start')}
          </VpButton>
        </div>
      </div>
    </div>,
    document.body,
  )
}
